module.exports = __webpack_public_path__ + "static/media/floriel_full_logo.d24ab8f3.png";